import { Collection } from "@maxeb/art-sdk";
import { SetState, State, initialState } from "./State";

export function setPending(state: State, setState: SetState) {
  setState({
    ...state,
    status: "pending",
  });
}
export function reload(state: State, setState: SetState) {
  setState({
    ...state,
    status: "success",
  });
  setTimeout(() => {
    setState({
      ...state,
      status: "ok",
    });
  }, 1000);
}
export function reset(state: State, setState: SetState) {
  setState(initialState());
}
export function setValues(
  props: { values: State["values"] },
  state: State,
  setState: SetState
) {
  const { values } = props;
  setState({
    ...state,
    values,
  });
}
export async function save(state: State, setState: SetState) {
  setState({ ...state, status: "pending" });

  try {
    const response = await Collection.add({
      name: state.values.name || "",
      description: state.values.description,
      thumb: state.values.thumb,
      public: Boolean(state.values.public),
      weight: 0,
    });

    if (response.isSuccess()) {
      setState({ ...state, status: "success" });

      const result = response.getResult();
      return { id: result.data.id, name: state.values.name };
    } else {
      const errors = response.getErrors({
        "body.thumb": "thumb",
        "body.name": "name",
        "body.description": "description",
        "body.public": "public",
      });

      return setState({
        ...state,
        status: "ok",
        errors: errors,
      });
    }
  } catch (error) {
    console.error(error);
  }
  setState({ ...state, errors: {}, status: "error" });
}
